import { render, staticRenderFns } from "./ErrorNotification.vue?vue&type=template&id=39e0b817&lang=pug&"
import script from "./ErrorNotification.vue?vue&type=script&lang=js&"
export * from "./ErrorNotification.vue?vue&type=script&lang=js&"
import style0 from "./ErrorNotification.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports